import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../@theme/services/clients.service'
import { TypesServices } from '../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../reps/shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../reps/shared/rep-editor-state.service'

@Component({
  selector: 'gd-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  imports: [
    CommonModule,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    GridToolbarFocusableDirective,
    AddCommandDirective,
    KENDO_BUTTONS,
    KENDO_INPUTS,
    ColumnComponent,
    EditTemplateDirective,
    TextBoxDirective,
    FormsModule,
    ReactiveFormsModule,
    CellTemplateDirective,
    CommandColumnComponent,
    FocusableDirective,
    EditCommandDirective,
    SaveCommandDirective,
    CancelCommandDirective,
  ]
})
export class EventsComponent extends GridEditorBaseComponent implements OnInit {
  public events: any[]

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnInit() {
    this.initGrid()
  }

  initGrid(): void {
    this.typesService.getEvents().subscribe((response) => {
      this.events = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const event = formGroup.value
    this.typesService.submitEventUpdate(event).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        eventId: 0,
        eventDescription: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(event: any): UntypedFormGroup {
    return this.formBuilder.group({
      eventId: [event.eventId, Validators.required],
      eventDescription: [event.eventDescription, Validators.required],
      active: event.active,
    })
  }
}
